"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCardUnderReview = exports.isCardProcessed = void 0;
var _core = require("@monument/core");
var isCardProcessed = function isCardProcessed(cardStatus) {
  if (!cardStatus) {
    return false;
  }
  return [_core.INSURANCE_CARD_STATUSES.ACTIVE, _core.INSURANCE_CARD_STATUSES.OPTED_OUT, _core.INSURANCE_CARD_STATUSES.ELIGIBLE, _core.INSURANCE_CARD_STATUSES.INELIGIBLE].includes(cardStatus);
};
exports.isCardProcessed = isCardProcessed;
var isCardUnderReview = function isCardUnderReview(cardStatus) {
  return cardStatus === _core.INSURANCE_CARD_STATUSES.PENDING;
};
exports.isCardUnderReview = isCardUnderReview;